import { render, staticRenderFns } from "./UIDropdown.vue?vue&type=template&id=37769ace&scoped=true"
import script from "./UIDropdown.vue?vue&type=script&lang=js"
export * from "./UIDropdown.vue?vue&type=script&lang=js"
import style0 from "./UIDropdown.vue?vue&type=style&index=0&id=37769ace&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37769ace",
  null
  
)

export default component.exports